import { useContext, useEffect, useRef } from 'react';
import WebUniversalNewEx, { initDataType, WUExtendPropsType } from '../../system/WebUniversalNewEx';
import { columnsheadId } from '../../universal/columnshead';
import AntDraggableModal from '../../../utils/extend/AntDraggableModal';
import MenuIntroductionEdit from './MenuIntroductionEdit';
import { Button, Switch, Tooltip } from 'antd';
import fetchApi from '../../../utils/api/fetchApi';
import system from "../../../config/systematic";
import antMessage from '../../../utils/extend/AntdNotification';
import { showCustomNotification, useNotificationInstance } from '../../../utils/extend/AntdNotificationEx';
import { SocketContext } from '../../../App';

export default function MenuIntroduction(props: any) {

    const ref = useRef<any>(undefined);
    const useContextData = useContext(SocketContext);

    const { closeModal, data } = props;
    const { contextData, setContextData } = useContextData;
    
    const notificationApi = useNotificationInstance();

    /** api服务id */
    const apiId = 'menuIntroduction';

    /** 后端数据Service */
    let wmService = system.wmService;

    useEffect(() => {
        //同步获取数据 async - await
        const fetchData = async () => {
        }
        fetchData();
        //禁用规则
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); //初始化数据

    //表头
    const columnsHead = [
        {
            title: '区域',
            dataIndex: 'areaName',
            render: (text: any, record: any) => {
                return (
                    <div>{record.area.areaName}</div>
                )
            }
        },
        {
            title: '菜名',
            dataIndex: 'foodName',
            render: (text: any, record: any) =>
                <div>{record.menuWarehouse.foodName}</div>
        },
        {
            title: '介绍',
            dataIndex: 'introduction',
            render: (text: any) => <Tooltip placement="topLeft" title={text}>{
                (typeof text !== "undefined" && text !== null) ?
                    (text.length >= 8 ? text.substring(0, 15) + '....' : text)
                    : ''
            }</Tooltip>
        },
        {
            title: '出处',
            dataIndex: 'source',
            render: (text: any) => <Tooltip placement="topLeft" title={text}>{
                (typeof text !== "undefined" && text !== null) ?
                    (text.length >= 8 ? text.substring(0, 6) + '....' : text)
                    : ''
            }</Tooltip>
        },
        {
            title: '排序',
            dataIndex: 'sortBy',
        },
        {
            title: '默认',
            dataIndex: 'isDefault',
            render: (text: any, record: any) => {
                return (
                    <Switch checkedChildren="是" unCheckedChildren="否"
                        checked={text} key={record.id}
                        onChange={(e) => handleChange(record, e)}
                    />
                )
            }
        },
    ];
    console.log(data);

    //更新智库介绍
    const handleIntroduction = async (id: any) => {
        fetchApi.PUT(wmService, {
            apiId,
            apiVariable: id,
            apiExtend: "checkIntroduction",
            apiData: {
                areaId: contextData?.currentAreaId,
            }
        }).then(async res => {
            if (res.success) {
                showCustomNotification(notificationApi!, {
                    type: 'success',
                    message: '更新成功',
                    description: 'success',
                });
                await initData();
            }
        }).catch(err => {
            antMessage('error', '更新失败', err.message);
        })
    };

    const initData = async () => {
        // const menuHeadId = data.menuHeadId;
        const currentData: initDataType = {
            apiId,
            // sendPageData: { menuHeadId: menuHeadId }
        }
        ref.current.initData(currentData);
    }

    //改变数据
    const handleChange = async (data: any, isValue: boolean) => {
        fetchApi.PUT(wmService, {
            apiId,
            apiVariable: data.id,
            apiExtend: "updateDefault",
            apiData: {
                data,
                isValue
            }
        }).then(async res => {
            if (res.success) {
                showCustomNotification(notificationApi!, {
                    type: 'success',
                    message: '修改成功',
                    description: 'success',
                });
                await initData();
            }
        }).catch(err => {
            antMessage('error', '修改失败', err.message);
        })
    };

    const columns = columnsheadId
        .concat(columnsHead as []);

    let extendProps: WUExtendPropsType = {
        ...props,
        titleName: '菜式介绍',
        apiId,
        columns,
        showStates: true,
        pagination: true,
        EditComponent: MenuIntroductionEdit,
        sendPageData: {
            menuWarehouseId: data.id,
            foodName: data.foodName
        }
    };

    return (
        <AntDraggableModal
            title={'菜式介绍'}
            open={true}
            okText='关闭'
            cancelButtonProps={{ style: { display: "none" } }}
            onOk={() => closeModal(true)}
            closable={false}
            maskClosable={false}
            width={1000}
        >
            <Button type="primary" onClick={() => handleIntroduction(data.id)}>更新智库介绍</Button>
            &nbsp;&nbsp;&nbsp;&nbsp;
            <WebUniversalNewEx props={extendProps} ref={ref} ></WebUniversalNewEx>
        </AntDraggableModal>
    )
}